import axiosInstance from "../../apiAxios/axiosInstance";


export const getRemarkList = async (payload) => {
  const response = await axiosInstance.post("/admin/lead-remark-list", payload);
  return response.data;
};


export const getLeadDetails = async (id) => {
  const response = await axiosInstance.post(
    "/admin/lead-show",
    { id }
  );

  return response.data;
};
export const updateLead = (paylod) =>
  axiosInstance.post("/admin/lead-update", paylod)
//remark reporting
export const RemarkReportingDatewiseCount = async (payload) => {
  const response = await axiosInstance.post("/admin/lead-remark-list", payload);
  return response.data;
}


